// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"529":"7bcf474f","549":"3111f4dc"}[chunkId] + ".chunk.css";
};